import React from 'react';
import { COLORS } from './chartTheme';

const DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

// Weekday x hour activity grid (GitHub-style).
//   grid: number[7][24]  (row 0 = Monday)
export default function Heatmap({ grid = [], color = COLORS.teal, cell = 18, gap = 3 }) {
  const max = Math.max(1, ...grid.flat());
  const labelW = 34;
  const W = labelW + 24 * (cell + gap);
  const H = 7 * (cell + gap) + 16;
  if (!grid.length) return <div className="ck-empty">No data</div>;
  return (
    <div className="ck-wrap">
      <svg viewBox={`0 0 ${W} ${H}`} className="ck-svg" aria-hidden="true">
        {grid.map((row, d) => (
          <g key={DAYS[d]}>
            <text x={labelW - 8} y={d * (cell + gap) + cell * 0.72} className="ck-tick" textAnchor="end">
              {DAYS[d]}
            </text>
            {row.map((v, h) => (
              <rect
                key={h}
                x={labelW + h * (cell + gap)}
                y={d * (cell + gap)}
                width={cell}
                height={cell}
                rx="3"
                fill={color}
                fillOpacity={v ? 0.15 + 0.85 * (v / max) : 0.05}
                className="ck-cell"
              >
                <title>{`${DAYS[d]} ${h}:00 — ${v} run${v === 1 ? '' : 's'}`}</title>
              </rect>
            ))}
          </g>
        ))}
        {[0, 6, 12, 18, 23].map((h) => (
          <text key={h} x={labelW + h * (cell + gap) + cell / 2} y={H - 2} className="ck-tick" textAnchor="middle">
            {h}
          </text>
        ))}
      </svg>
    </div>
  );
}
